export default "__VITE_ASSET__CAS3lehO__"